<template>
	<div>
		<video class="bg-video" src="/footage/paratoner.mp4" autoplay muted loop></video>
		<router-link :to="{name:'madalyon'}" class="page-nav-link" id="link-left"><img class="link-image" src="images/arrow-down-white-01.png" alt="" style="max-height: 50px;"></router-link>

		<a href="https://www.twitch.tv/itflashediturnedaway/clips?filter=clips&range=all" target="_blank" class="page-nav-link" id="link-right"><img class="link-image" src="images/arrow-up-white-02.png" alt="" style="max-height: 50px;"></a>

	</div>
</template>

<script>
	import CircleLink from "../components/CircleLink"
	import _ from 'lodash'

	export default {
		name: "ParatonerPage",
		components: {CircleLink,},
		computed: {
			pageLinks: function () {
				var thisPagesLinks = _.find(this.$store.state.linksCollection, {'pageName': 'agac'})
				return thisPagesLinks.pageLinks
			}
		}

	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}

	.page-nav-link {
		position: absolute;
		top: 50%;
	}

	#link-left {
		left: 20px;
	}

	#link-right {
		right: 20px;
	}
</style>